import store from './store';
import ConfigurationService from "./services/ConfigurationService";
import ShopifyAdapterService from "./services/shopify/ShopifyAdapterService";
import ProductPageService from './services/shopify/pages/ProductPageService';
import OrderPageService from './services/shopify/pages/OrderPageService';

// plugins
import './plugins/Axios';

class App {
  init() {
    ConfigurationService.init();
    this.initPageLoadEvents();
    store.dispatch('local/load');

    ShopifyAdapterService.emmitPageLoad();
  }

  initPageLoadEvents() {
    /** Event that will be triggered on product page load */
    ShopifyAdapterService.onPageLoad('product', ProductPageService.handle.bind(ProductPageService));
    /** Event that will be triggered on order status page load ("Thank you" page) */
    ShopifyAdapterService.onPageLoad('order', OrderPageService.handle.bind(OrderPageService));
  }

  /** TODO: remove on production, or disable with config option */
  get store() {
    return store;
  }
}

export default new App();
